import {
  choferPartialBuilder,
  ChoferPartialModel
} from 'app/chofer/models/Chofer';
import {
  transferReservationPartialBuilder,
  TransferReservationPartialModel
} from 'app/viaje/viajeTraslado/viajeTraslado/models/TransferReservationPartial';

export interface TransferReservationPendingModel
  extends TransferReservationPartialModel {
  preAssignedDriver: ChoferPartialModel | null;
  isReserveForTheMoment: boolean;
  preassigned_driver_draft?: string | null;
  edited_with_driver_assigned: boolean;
}

export const transferReservationPendingBuilder = {
  fromBackEnd: (reservation): TransferReservationPendingModel => ({
    ...transferReservationPartialBuilder.fromBackEnd(reservation),
    preAssignedDriver: reservation.pre_assigned_driver
      ? choferPartialBuilder.fromBackEnd(reservation.pre_assigned_driver)
      : null,
    isReserveForTheMoment: reservation.isReserveForTheMoment,
    preassigned_driver_draft: reservation.preassigned_driver_draft ?? null,
    edited_with_driver_assigned: reservation.edited_with_driver_assigned
  })
};
